module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-left-top-backplates.5b8c100b.png";